import { AttrField, HasManyByField, NumberField, OrmModel, StringField } from 'vuex-orm-decorators'
import { modelNames } from '@/data/models/types'
import BaseModel from '@/data/models/BaseModel'
import type { SessionSource, SessionDestination } from '@/types'
import Label from '@/data/models/domain/Label'
import { TmArrayStringField } from '@/data/utils/types'

@OrmModel(modelNames.SESSION_SHORT)
export default class SessionShort extends BaseModel {
  @StringField(null)
  public title: string | null

  @StringField()
  public startTime: string

  @StringField()
  public text: string

  @NumberField()
  public price: number

  @NumberField()
  public numbersCount: number

  @StringField()
  public destination: SessionDestination

  @StringField()
  public source: SessionSource

  @StringField()
  public referenceId: string

  @StringField()
  public fromEmail: string

  @AttrField(null, (t: unknown) => {
    if (typeof t === 'number') {
      return t.toString()
    }
    return t
  })
  public initiatorId: string | null

  @StringField(null)
  public createdByAutomationId: string | null

  @TmArrayStringField()
  public labelIds: string[]

  @HasManyByField(Label, 'labelIds')
  public labels: Label[]
}
